import { Routes } from '@angular/router';

import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

import { HomeComponent } from './pages/home/home.component';
import { ProductTranslationComponent } from './partials/product-translation/product-translation.component';
import { SizeMapComponent } from './partials/size-map/size-map.component';
import { ImportSizeGroupsComponent } from './pages/import-size-groups/import-size-groups.component';
import { ImportSizeGuidesComponent } from './pages/import-size-guides/import-size-guides.component';
import { IntegrationQueueComponent } from './pages/integration-queue/integration-queue.component';
import { MediaIntegrationLogComponent } from './pages/media-integration-log/media-integration-log.component';
import { ProcessingQueueComponent } from './pages/processing-queue/processing-queue.component';
import { GlobalListTranslationComponent } from './partials/global-list-translation/global-list-translation.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent, // 👈 layout wrapper
    children: [
      { path: '', component: HomeComponent }, // default page
      { path: 'pages/import-size-guides', component: ImportSizeGuidesComponent },
      { path: 'pages/import-size-groups', component: ImportSizeGroupsComponent },
      { path: 'pages/integration-queue', component: IntegrationQueueComponent },
      { path: 'pages/media-integration-log', component: MediaIntegrationLogComponent },
      { path: 'pages/processing-queue', component: ProcessingQueueComponent }
    ]
  },
  { path: 'producttranslation', component: ProductTranslationComponent },
  { path: 'globallisttranslation', component: GlobalListTranslationComponent },
  { path: 'sizemap', component: SizeMapComponent },  
  { path: '**', redirectTo: '' }
];